import React from "react";
import { Container, Row, Col, Image, ListGroup } from "react-bootstrap";
import AnimationRevealPage from "helpers/AnimationRevealPage";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import onsa from "images/onssa.jpg";
import dmp from "images/dmp.png";
import AboutUs from "./AboutUs"; // This component likely contains the image you want to make full width
import bg from "images/bg.jpg";
import P1 from "images/Satisfaction garantie.png";
import P2 from "images/livraison.png";
import P3 from "images/produits.png";

import styled from "styled-components";
import Light from "./headers/light";

// --- Styled Components (Previous ones, kept for context) ---
const StyledHero = styled.div`
  background-image: url(${bg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #336734; // <-- Add this line
  position: relative;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 0px 0 60px 0;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0);
  }
`;

const HeroTitle = styled.h1`
  color: #336734;
  font-weight: bold;
  font-size: 52px;
  margin: 0;
  position: relative;
  z-index: 2;
`;

// --- NEW Styled Component for the Certification Section ---
const CertificationSection = styled.div`
  padding: 30px 0;
  border-radius: 18px;
  margin-top: -100px;
  box-shadow: 0 4px 24px 0 rgba(51, 103, 52, 0.07);
`;

const SectionHeading = styled.h2`
  font-weight: bold;
  color: #336734; /* Brand color for main heading */
  font-size: 42px;
  text-align: center;
  margin-bottom: 20px;
`;

const SectionSubheading = styled.p`
  color: #555;
  font-size: 18px;
  text-align: center;
  max-width: 800px;
  margin: 0 auto 60px auto; /* Centered and more space below */
  line-height: 1.6;
`;

const CertificationLogos = styled.div`
  display: flex;
  justify-content: center; /* Center the logos */
  gap: 40px; /* More space between logos */
  margin-bottom: 60px; /* Space below logos */
  img {
    height: 80px; /* Larger logos */
    width: auto;
    filter: grayscale(100%); /* Desaturate for a sleek look */
    opacity: 0.7;
    transition: all 0.3s ease;
    &:hover {
      filter: grayscale(0%); /* Full color on hover */
      opacity: 1;
    }
  }
`;

const FeatureCard = styled.div`
  background-color: white;
  border-radius: 15px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08); /* Stronger shadow for cards */
  height: 100%; /* Ensure cards are same height */
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  transition: transform 0.3s ease;
  &:hover {
    transform: translateY(-10px); /* Lift on hover */
  }
`;

const CardTitle = styled.h3`
  color: #000000;
  font-size: 24px;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 15px;
`;

const CardDescription = styled.p`
  color: #777;
  font-size: 16px;
  line-height: 1.6;
`;

// --- NEW Styled Component for the Full Width Image Section ---
const FullWidthImageSection = styled.div`
  width: 100vw; /* Make it full viewport width */
  margin-left: calc(-50vw + 50%); /* Counteract parent container's centering */
  overflow: hidden; /* Hide any potential overflow from margin-left trick */
  margin-bottom: 60px; /* Add space below this section */

  // Important: If AboutUs contains a bootstrap Container, it will prevent full width.
  // You might need to modify AboutUs.js to remove its Container or replace it
  // with a simple div that allows its image child to be 100% width.
  // Assuming AboutUs directly contains or allows styling of an image:
  img {
    display: block; // Remove extra space below images
    width: 100%; // Make the image fill its container
    height: auto; // Maintain aspect ratio
    object-fit: cover; // Ensure image covers the area, possibly cropping
  }
`;

const CircleImageWrapper = styled.div`
  border: 3px solid #336734;
  border-radius: 50%;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  background: #fff;
`;

const AboutLadyCosmeticos = () => {
  return (
    <AnimationRevealPage>
      <Light />
      <br/>
      <StyledHero>
        <HeroTitle>À propos</HeroTitle>
      </StyledHero>

      {/* Wrap AboutUs in the new FullWidthImageSection */}
      <FullWidthImageSection>
        <AboutUs />
      </FullWidthImageSection>

      {/* --- NEW/REVISED CERTIFICATION SECTION --- */}
      <CertificationSection>
        <Container style={{ padding: 0 }}>
          <SectionHeading>Notre Engagement : Qualité et Confiance</SectionHeading>
          <SectionSubheading>
Chez Élancia Bio, nous ne sommes pas seulement une marque, mais un partenaire de vie, qui vous accompagne dans votre quête d’énergie, de santé et de beauté.
Nous vous invitons à découvrir nos gammes de produits naturels, pensées pour révéler votre éclat intérieur et extérieur.          </SectionSubheading>

          <CertificationLogos>
            <img src={onsa} alt="ONSSA Certification" />
            <img src={dmp} alt="DMP Certification" />
          </CertificationLogos>

          <Row className="justify-content-center">
            <Col md={6} lg={4} className="mb-4">
              <FeatureCard>
                <CircleImageWrapper>
                  <img src={P3} alt="Natural Ingredients" style={{ height: "90px", width: "90px", borderRadius: "50%", objectFit: "cover" }} />
                </CircleImageWrapper>
                <CardTitle>Produit Certifié Qualité Supérieure</CardTitle>
                <CardDescription>
Chaque produit que nous offrons est rigoureusement testé et certifié, garantissant une qualité et une pureité exceptionnelles.                 </CardDescription>
              </FeatureCard>
            </Col>
            <Col md={6} lg={4} className="mb-4">
              <FeatureCard>
                <CircleImageWrapper>
                  <img src={P2} alt="Strict Quality Control" style={{ height: "90px", width: "90px", borderRadius: "50%", objectFit: "cover" }} />
                </CircleImageWrapper>
                <CardTitle>Livraison Rapide et Fiable</CardTitle>
                <CardDescription>
Recevez vos produits en un temps record grâce à notre service de livraison optimisé. Votre bien-être est notre priorité, et nous veillons à ce que vos commandes arrivent rapidement et en parfait état.                </CardDescription>
           
              </FeatureCard>
            </Col>
            <Col md={6} lg={4} className="mb-4">
              <FeatureCard>
                <CircleImageWrapper>
                  <img src={P1} alt="Expert Formulation" style={{ height: "90px", width: "90px", borderRadius: "50%", objectFit: "cover" }} />
                </CircleImageWrapper>
                <CardTitle>Votre Satisfaction, Notre Engagement</CardTitle>
                <CardDescription>
Nous sommes tellement convaincus de la qualité de nos produits que nous vous offrons une garantie de satisfaction à 100%.                 </CardDescription>
              </FeatureCard>
            </Col>
          </Row>
        </Container>
      </CertificationSection>
      {/* --- END NEW/REVISED CERTIFICATION SECTION --- */}

      <Footer />
    </AnimationRevealPage>
  );
};

export default AboutLadyCosmeticos;